import React from "react";
import { EndbannerHomeItemDetalle } from "./EndbannerHomeItemDetalle";

function EndbannerHomeItem(props) {
  const displayItems = (props) => {
    const endbanners = props.endbannersHome

    if (props) {
      if (endbanners) {
        if (endbanners.length > 0) {
          return endbanners.map((endbanner, index) => {
            return (
              <EndbannerHomeItemDetalle key={index} endbannerHome={endbanner} deleteEndbannerHome={props.deleteEndbannerHome} />
            )
          })
        } else {
          return <h3>No hay banners</h3>
        }
      } else {
        return <h3>No hay banners</h3>
      }
    } else {
      return <h3>No hay banners</h3>
    }
  }
  return <>{displayItems(props)}</>
}

export {EndbannerHomeItem}